import React, { FC, useEffect } from 'react';
import { Form, Input, Modal as AntModal } from 'antd';
import { EMAIL, ENTER_EMAIL } from '../../../utils/constants/labels';
import SafeAction from '../SafeAction';
import { api } from '../../../api/api';
import { User } from '../../../types/userTypes';
import { notify } from '../../../utils/helpers';

type Props = {
  user?: User;
  onClose: () => void;
  onUserUpdate: Function;
};

const UpdateUserEmailModal: FC<Props> = ({ user, onClose, onUserUpdate }: Props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (user) {
      form.resetFields();
    }
  }, [user]);

  const renderContent = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div>Update organization user's email.</div>
        <Form form={form} style={{ display: 'flex', flexDirection: 'column' }} initialValues={{ email: user?.email }}>
          <Form.Item style={{ width: '100%' }} name="email" label={EMAIL} rules={[{ required: true, type: 'email' }]}>
            <Input type={'email'} placeholder={ENTER_EMAIL} />
          </Form.Item>
          <SafeAction
            title={'Save'}
            onError={(message: string) => notify(message)}
            action={() =>
              form
                .validateFields()
                .then(async values => {
                  const res = await api.changeUserEmail(user?.id!, values.email);
                  if (res.ok) {
                    onUserUpdate();
                  }
                  return res;
                })
                .catch(info => {
                  console.log('Validate Failed:', info);
                  return { ok: false, data: { message: 'Invalid email format' } };
                })
            }
            doneText={'Email updated'}
          />
        </Form>
      </div>
    );
  };
  return (
    <AntModal title={''} visible={!!user} footer={null} onCancel={() => onClose()}>
      {!!user && renderContent()}
    </AntModal>
  );
};

export default UpdateUserEmailModal;
